import _ from 'lodash';
import axios from 'axios';
import moment from 'moment';
import { connect } from 'react-redux';
import Flowchart from 'flowchart-react';
import FollowUpWork from './Follow-up Work';
import FailureReport from './Failure Report';
import Responsibility from './Responsibility';
import Highlighter from 'react-highlight-words';
import { decode as base64_decode } from 'base-64';
import FileBase64 from '../../../Utils/FileUpload';
import CommunicationLog from './Communication Log';
import { constant } from '../../../Utils/constants';
import WorkOrderJobPlanes from './WorkOrderJobPlanes';
import TableSelect from '../../../Widgets/TableSelect';
import SchedulingWorkOrder from './SchedulingWorkOrder';
import { API_DEVICE } from '../../../../../commons/api';
import React, { useState, useEffect, useRef } from 'react';
import translation from '../../../../../commons/translation';
import localStorage from '../../../../../utils/localStorage';
import InputComponent from '../../../Widgets/InputComponent';

import { Form, message, Select, Tabs, Row, Col, Tooltip, Drawer, Input, Modal,Button } from 'antd';
import {
  NodeExpandOutlined,
  ApartmentOutlined,
  DownOutlined,
  SearchOutlined
} from '@ant-design/icons';
import {
  getDeviceList,
  getOrganisationsList,
  getSitesList,
  submitWorkOrder,
  getJobPlansList,
  getJobPlanById,
  getLocationByAsset,
  getWorkTypes,
  getWorkFlows,
  getStatus,
  getWorkFlow,
  getWorkOrderById,
  workOrderStatus
} from '../../../Utils/FormCalls';

const { Option } = Select;
const { TabPane } = Tabs;

const WorkOrderDetails = (props) => {
  const [deviceList, setDeviceList] = useState([]);
  const [, setOrganisationsList] = useState([]);
  const [sitesList, setSitesList] = useState([]);
  const [workTypesList, setWorkTypesList] = useState([]);
  const [workFlowsList, setWorkFlowsList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [formObject, setFormObject] = useState(props.formObject && Object.keys(props.formObject).length > 0 ? props.formObject : {});
  const [activeKey, setActiveKey] = useState('1');
  const [tableData, setTableData] = useState([]);
  const [selectedJobPlan, setSelectedJobPlan] = useState(props.formObject && props.formObject.JobPlanName ? props.formObject.JobPlanName : '');
  // const  setJobplanActivekey = useState('1');
  const [jobPlansList, setJobPlansList] = useState([]);
  const [noJobplan, setNoJobplan] = useState(false);
  const [visible, setVisible] = useState(false);
  const [workFlow, setWorkFlow] = useState({});
  const [initate, setInitate] = useState(false);
  const [visibleModal, setVisibleModal] = useState(false);
  const [translationCache, setTranslationCache] = useState(props.translationCache || {});
  const [fileUploadList, setFileUploadList] = useState([]);
  const [DeviceAlias, setDeviceAlias] = useState('');
  const [searchText, setSearchText] = useState([]);
  const [fileData, setFileData] = useState({});
  const workOrderRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      await _getDataById();
      try {
        const deviceList = await getDeviceList();
        const organisationsList = await getOrganisationsList();
        const workTypesList = await getWorkTypes();
        const JobPlansList = await getJobPlansList('Active');
        const sitesList = await getSitesList();
        setSitesList(sitesList);
        setWorkTypesList(workTypesList);
        setOrganisationsList(organisationsList);
        setJobPlansList(JobPlansList);
        setDeviceList(deviceList);
      } catch (error) {
        message.warning(`${error.message}`);

      }
    };
    fetchData();
  }, []);

  const _getDataById = async () => {
    let formObject = {};
    let path = props.location.pathname.split('/rubus/AMM/WorkOrderDetails/');
    let formId = base64_decode(path[1]);
    let statusList = await getStatus();
    if (formId !== 'new') {
      formObject = await getWorkOrderById(base64_decode(path[1]), 'withId');
      let workFlowsList = await getWorkFlows(formObject.WorkTypeId);
      _.cloneDeepWith(formObject, (value) => {
        return value && value !== null
          ? {
            ...value,
            ...(value['StartTime'] = moment.utc(value.StartTime, 'YYYY-MM-DD HH:mm:ss')),
            ...(value['EndTime'] = moment.utc(value.EndTime, 'YYYY-MM-DD HH:mm:ss')),
            ...(value['JobPlan'] &&
              value['JobPlan']['TaskData'] &&
              value['JobPlan']['TaskData'].map((item, i) => {
                return value['JobPlan']['TaskData'][i]
                  ? (value['JobPlan']['TaskData'][i]['StartTime']
                    ? (value['JobPlan']['TaskData'][i]['StartTime'] = moment
                      .utc(
                        value['JobPlan']['TaskData'][i]['StartTime'],
                        'YYYY-MM-DD HH:mm:ss'
                      )
                      .local())
                    : null,
                    value['JobPlan']['TaskData'][i]['EndTime']
                      ? (value['JobPlan']['TaskData'][i]['EndTime'] = moment
                        .utc(value['JobPlan']['TaskData'][i]['EndTime'], 'YYYY-MM-DD HH:mm:ss')
                        .local())
                      : null)
                  : null;
              }))
          }
          : _.noop();
      });
      setWorkFlowsList(workFlowsList);
      setDeviceAlias(formObject.DeviceAlias);
    } else if (formId === 'new') {
      let formObject = workOrderRef.current && workOrderRef.current.getFieldsValue();
      formObject = {
        ...formObject,
        SiteId: localStorage.get('currentSite') ? parseInt(localStorage.get('currentSite')) : ''
      };
      workOrderRef.current && workOrderRef.current.setFieldsValue(formObject);
      if (formObject && formObject.Id) {
        let WAPPRStatus =
          statusList && Array.isArray(statusList)
            ? statusList.filter((status) => status.Status === 'WAPPR')
            : [];
        let WOStatusId = WAPPRStatus && WAPPRStatus[0] ? WAPPRStatus[0].Id : undefined;
        handleChange(formObject.Id, 'WorkOrder');
        handleChange(WOStatusId, 'WOStatusId');
      }
    }
    setFormObject(formObject);
    setStatusList(statusList);
    setSelectedJobPlan(formObject && formObject.JobPlanName ? formObject.JobPlanName : '');
    if (formObject && workOrderRef.current) {
      workOrderRef.current.setFieldsValue(formObject);
    }
  };

  useEffect(() => {
    if (props.formObject && Object.keys(props.formObject).length === 0 && Object.keys(formObject).length === 0) {
      onReset();
    }
    if (props.translationCache !== translationCache) {
      setTranslationCache(props.translationCache);
    }
    if (props.formObject && Object.keys(props.formObject).length === 0) {
      workOrderRef.current && workOrderRef.current.setFieldsValue(props.formObject);
    }

    if (props.formObject && Object.keys(props.formObject).length > 0) {
      if (props.formObject && props.formObject.Id) {
        handleChange(props.formObject.Id, 'WorkOrder');
      }
      setFormObject(props.formObject);
    }
  }, [props.formObject, props.translationCache]);

  // const handleSelect = (value, mainIndex, subindex, keyName) => {
  //   let list = {};
  //   let TaskData = list;
  //   TaskData.map((item, index) => {
  //     if (index === mainIndex) {
  //       item[keyName][subindex]['TotalQuantity'] = value;
  //     }
  //     return {};
  //   });
  // };

  const handleChange = async (value, key) => {
    let formObject = workOrderRef.current ? workOrderRef.current.getFieldsValue() : {};
    formObject = {
      ...formObject,
      [key]: value
    };
    if (key === 'Device') {
      let selectedDevice = deviceList.filter((item) => item.AliasCode === value);
      let location = await getLocationByAsset(selectedDevice[0].Asset);
      formObject = {
        ...formObject,
        [key]: value,
        LocationId: location.Name
      };
    } else if (key === 'WorkTypeId') {
      // let workFlowsList = await getWorkFlows(value);
    } else if (key === 'WorkFlowId') {
      // let workTypesList = await getWorkTypes(value);
    }

    workOrderRef.current && workOrderRef.current.setFieldsValue(formObject);
    setFormObject(formObject);
    setWorkFlowsList(workFlowsList);
    setWorkTypesList(workTypesList);

  };

  const fileupload = async (values, key, fileDataObject) => {
    let formObject = workOrderRef.current && workOrderRef.current.getFieldsValue();
    let updatedFileUploadList = [...fileUploadList];
    if (formObject && formObject[key]) {
      formObject[key].push(...values);
    } else {
      formObject[key] = [{ [key]: values }];
    }
    updatedFileUploadList.push({ fileDataObject });
    setFileUploadList(updatedFileUploadList);
    workOrderRef.current && workOrderRef.current.setFieldsValue(formObject);
    setFormObject(formObject);
  };

  const jobPlanfileUpload = async (values, key, fileDataObject, JobPlanId) => {
    let formObject = workOrderRef.current && workOrderRef.current.getFieldsValue();
    if (formObject && formObject['JobPlan'] && formObject['JobPlan'][key]) {
      formObject['JobPlan'][key].push(...values);
    } else if (formObject && formObject['JobPlan']) {
      formObject['JobPlan'][key] = values;
    } else {
      formObject['JobPlan'] = { [key]: values };
    }
    let updatedJobPlanList = [...fileUploadList.JobPlan || []];
    updatedJobPlanList.push({ fileDataObject, JobPlanId });
    setFileUploadList({ ...fileUploadList, JobPlan: updatedJobPlanList });
    workOrderRef.current && workOrderRef.current.setFieldsValue(formObject);
    setFormObject(formObject);
  };
  const onFinish = async (values, key, fileData) => {
    let currentFormObject = workOrderRef.current && workOrderRef.current.getFieldsValue();
    currentFormObject = {
      ...currentFormObject,
      [key]: {
        ...currentFormObject[key],
        ...values
      }
    };

    setFormObject(currentFormObject);
    setFileData(fileData);
    setNoJobplan(true);

    if (workOrderRef.current) {
      workOrderRef.current.setFieldsValue(currentFormObject);
    }
  };

  const onFormsubmit = async () => {
    let payload = {
      ...formObject,
      DeviceAlias
    };
    if (!formObject.JobPlan) {
      message.info('Please Provide at least one Jobplan/Task');
    } else if (noJobplan) {
      let statusResponse = await submitWorkOrder(payload, fileUploadList);
      if (statusResponse && statusResponse.message) {
        _getDataById(statusResponse.Id);
        message.success(statusResponse.message);
        props.navigate('/rubus/AMM/WorkOrderList');
      } else if (statusResponse && statusResponse.Error) {
        message.error(statusResponse.Error);
      }
    } else {
      message.error('Please save before you submit the Workorder');
    }
  };

  const onReset = () => {
    workOrderRef.current && workOrderRef.current.resetFields();
  };

  const jobPlanOnChange = async (value) => {
    let jobplanData = await getJobPlanById(value, 'withoutId');
    let formObject = workOrderRef.current ? workOrderRef.current.getFieldsValue() : {};
    _.cloneDeepWith(jobplanData && jobplanData['TaskData'], (value) => {
      return value && value !== null && value.StartTime
        ? {
          ...value,
          ...(value['StartTime'] = moment.utc(value.StartTime, 'YYYY-MM-DD HH:mm:ss')),
          ...(value['EndTime'] = moment.utc(value.EndTime, 'YYYY-MM-DD HH:mm:ss'))
        }
        : _.noop();
    });
    formObject = { ...formObject, JobPlan: jobplanData };
    workOrderRef.current && workOrderRef.current.setFieldsValue(formObject);
    setSelectedJobPlan(value);
    setFormObject(formObject);
  };

  const viewWorkFlow = async () => {
    let NodeData = await getWorkFlow(formObject && formObject.WorkFlowId ? formObject.WorkFlowId : null);
    if (NodeData && NodeData[0]) setWorkFlow(NodeData[0] && NodeData[0].Node);
    setVisible(true);
  };

  const initateWorkOrder = async () => {
    let formObject = workOrderRef.current && workOrderRef.current.getFieldsValue();
    let payload = {
      Id: formObject.Id,
      WorkFlowId: formObject.WorkFlowId,
      WfStatus: 'Submit',
      WorkTypeId: formObject.WorkTypeId,
      WorkOrderName: formObject.Id,
      RoleId: JSON.parse(localStorage.get('roleId'))
    };
    let initateWO = await workOrderStatus(payload);
    if (initateWO && initateWO.message) {
      message.info(`${initateWO.message}`);
      setInitate(true);
    }
  };

  const handleCancel = () => {
    setVisible(false);
  };

  // const getValueFromList = (list, compareKey, compareValue, resultKey) => {
  //   let filterObject = [];
  //   if (list && Array.isArray(list)) {
  //     filterObject = list.filter((listObject) => listObject[compareKey] === compareValue);
  //   }
  //   return filterObject && filterObject[0] && filterObject[0][resultKey]
  //     ? filterObject[0][resultKey]
  //     : '';
  // };

  const TableDropdownChange = (value) => {
    let formObject = workOrderRef.current && workOrderRef.current.getFieldsValue();
    formObject = {
      ...formObject,
      DeviceAlias: value.AliasCode,
      DeviceCode: value.DeviceCode,
      DisplayCode: value.DisplayCode,
      EquipmentDescription: value.Name,
      LocationId: value.Asset,
      AssetDisplayCode: value.AssetDisplayCode,
      LocationDescription: value.AssetDescription
    };
    workOrderRef.current && workOrderRef.current.setFieldsValue(formObject);
    setFormObject(formObject);
    setDeviceAlias(value && value.AliasCode);
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
    setSearchText(selectedKeys[0]);
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters();
    handleSearch([], confirm);
  };

  const onDrawerCancel = (e) => {
    let formObject = workOrderRef.current && workOrderRef.current.getFieldsValue();
    if (formObject.Equipment === undefined && e.target.tagName === 'DIV') {
      e.preventDefault();
      return message.error(`Please Click On Cancel`);
    } else {
      setVisibleModal(false);
    }
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={(node) => {
            this.searchInput = node;
          }}
          placeholder={translation(props.translationCache, constant.search)}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {translation(props.translationCache, constant.search)}
        </Button>
        <Button
          danger
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {translation(props.translationCache, constant.Reset)}
        </Button>

      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record &&
      record[dataIndex] &&
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const getDeviceData = () => {
    const siteId = localStorage.get('currentSite');
    const accessToken = localStorage.get('accessToken');
    let headers = {
      method: 'GET',
      url: `${API_DEVICE.LIST}?SiteId=${siteId}`,
      headers: {
        Authorization: `Bearer ${accessToken}`
      }
    };
    axios(headers)
      .then(({ data }) => {
        tableData(data),
          setFormObject(workOrderRef.current && workOrderRef.current.getFieldsValue());
      })
      .catch(function () { });


  };
  const validateMessages = {
    required: '${label} is required!',
    types: {
      email: '${label} is not a valid email!',
      number: '${label} is not a valid number!'
    },
    number: {
      range: '${label} must be between ${min} and ${max}'
    },
    pattern: {
      mismatch: '${label} does not match pattern'
    }
  };

  return (
    <>
      <Drawer
        open={visible}
        width={window.innerWidth > 19000 ? 18000 : window.innerWidth - 100}
        onClose={handleCancel}
        title="WorkFlow Flow Chart"
      >
        <Flowchart
          showToolbar={false}
          style={{ width: '100%', height: 500 }}
          nodes={workFlow && workFlow.nodes}
          connections={workFlow && workFlow.connections}
        />
      </Drawer>
      <Form
        ref={workOrderRef}
        onFinish={onFormsubmit}
        onKeyDown={(e) => {
          e.key === 'Enter' && e.preventDefault();
        }}
        initialValues={formObject}
        layout="horizontal"
        labelCol={{ flex: '130px' }}
        labelAlign="right"
        labelWrap
        disabled={formObject && formObject['WOStatusId'] === 5 ? true : false}
        validateMessages={validateMessages}
      >
        <div style={{ display: 'flex', justifyContent: 'right' }}>
          <Form.Item>
            <Button type='primary' htmlType="submit">
              {translation(translationCache, constant.submit)}
            </Button>
          </Form.Item>
        </div>
        <Row style={{ display: 'flex', flexDirection: 'row-reverse' }}>
          <Col style={{ width: '45px' }}>
            {formObject && formObject.Id ? (
              <Tooltip title="View WorkFlow">
                <Button
                  onClick={viewWorkFlow}
                  shape="circle"
                  icon={<ApartmentOutlined />}
                />
              </Tooltip>
            ) : null}
          </Col>
          <Col style={{ width: '45px' }}>
            {formObject && formObject.Id ? (
              <Tooltip title="Initiate WorkFlow">
                <Button
                  disabled={formObject && formObject.RecordStatus === null && initate === false ? false : true}
                  onClick={initateWorkOrder}
                  shape="circle"
                  icon={<NodeExpandOutlined />}
                />
              </Tooltip>
            ) : null}
          </Col>
        </Row>
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <Form.Item name="Id"></Form.Item>
          <Form.Item
            label={translation(translationCache, constant.workOrderDescription)}
            name="Description"
            style={{ width: '100%', flex: '50%' }}
            rules={[{ required: true }]}
          >
            <InputComponent
              placeholder={translation(translationCache, 'Input WorkOrderDescription')}
              onChange={(e) => handleChange(e.target.value, 'Description')}
              style={{ width: '70%' }}
            />
          </Form.Item>
          <Form.Item name="Device"></Form.Item>
          <Form.Item
            label={translation(translationCache, constant.equipment)}
            name="DisplayCode"
            style={{
              width: '100%',
              flex: '50%'
            }}
            rules={[{ required: true }]}
          >
            <InputComponent
              disabled={true}
              suffix={
                <DownOutlined
                  style={{
                    color: formObject && formObject.Id ? null : '#1a3b5c',
                    cursor: formObject && formObject.Id ? 'not-allowed' : null,
                    opacity: formObject && formObject.Id ? '0.8' : null
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    if (formObject && !formObject.Id) {
                      getDeviceData('visibleModal');
                    }
                  }}
                />
              }
              style={{ width: '70%' }}
              placeholder={translation(translationCache, constant.SelectEquipment)}
            />
          </Form.Item>
          <Modal
            open={visibleModal}
            width={800}
            closable
            title={translation(translationCache, constant.selectEquipment)}
            // onOk={onModalOk}
            onCancel={onDrawerCancel}
          >
            <TableSelect
              data={setTableData}
              translationCache={props.translationCache}
              key="Equipment"
              columns={[
                {
                  title: translation(translationCache, 'Equipment'),
                  dataIndex: 'DisplayCode',
                  key: 'DisplayCode',
                  ...getColumnSearchProps('DisplayCode')
                },
                {
                  title: translation(translationCache, 'Equipment Description'),
                  dataIndex: 'Name',
                  key: 'Name',
                  ...getColumnSearchProps('Name')
                }
              ]}
              handleDropdownChange={(e) => TableDropdownChange(e, 'visibleModal')}
            />
          </Modal>
          <Form.Item
            style={{
              width: '100%',
              flex: '50%'
            }}
            label={translation(translationCache, constant.equipmentDescription)}
            name="EquipmentDescription"
            rules={[{ required: true }]}
          >
            <InputComponent
              style={{ width: '70%' }}
              placeholder={translation(translationCache, 'Autopopulate based on Equipment')}
              disabled={true}
            />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, constant.location)}
            style={{
              width: '100%',
              flex: '50%'
            }}
            name="AssetDisplayCode"
          >
            <InputComponent
              placeholder={translation(translationCache, 'Input Location')}
              disabled={true}
              style={{ width: '70%' }}
            />
          </Form.Item>
          <Form.Item
            style={{
              width: '100%',
              flex: '50%'
            }}
            label={translation(translationCache, constant.locationDescription)}
            name="LocationDescription"
            rules={[{ required: true }]}
          >
            <InputComponent
              style={{ width: '70%' }}
              placeholder={translation(translationCache, 'Enter Location Description')}
              disabled={true}
            />
          </Form.Item>
          <Form.Item
            label={translation(translationCache, constant.site)}
            name="SiteId"
            style={{
              width: '100%',
              flex: '50%'
            }}
            rules={[{ required: true }]}
          >
            <Select
              placeholder={translation(translationCache, 'Select Site')}
              onChange={(value) => handleChange(value, 'SiteId')}
              style={{ width: '70%' }}
            >
              {sitesList.map((site, index) => (
                <Option key={index} value={site.Id}>
                  {site.Name}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label={translation(translationCache, constant.workType)}
            name="WorkTypeId"
            style={{ width: '100%', flex: '50%' }}
            rules={[{ required: true }]}
          >
            <Select
              placeholder={translation(translationCache, 'Select Work Type')}
              onChange={(value) => handleChange(value, 'WorkTypeId')}
              style={{ width: '70%' }}
            >
              {workTypesList.map((workType, index) => (
                <Option key={index} value={workType.Id}>
                  {workType.WorkType}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label={translation(translationCache, constant.workFlow)}
            name="WorkFlowId"
            style={{ width: '100%', flex: '50%' }}
            rules={[{ required: true }]}
          >
            <Select
              placeholder={translation(translationCache, 'Select Work Flow')}
              onChange={(value) => handleChange(value, 'WorkFlowId')}
              style={{ width: '70%' }}
            >
              {workFlowsList.map((workFlow, index) => (
                <Option key={index} value={workFlow.Id}>
                  {workFlow.WorkFlowName}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            label={translation(translationCache, constant.status)}
            name="WOStatusId"
            style={{ width: '100%', flex: '50' }}
            rules={[{ required: true }]}
          >
            <Select
              placeholder={translation(translationCache, 'Select Status')}
              onChange={(value) => handleChange(value, 'WOStatusId')}
              style={{ width: '70%' }}
            >
              {statusList.map((status, index) => (
                <Option key={index} value={status.Id}>
                  {status.Status}
                </Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            name="Attachments"
            style={{ width: '100%', flex: '50%' }}
            label="Attachments"
          >
            <FileBase64
              className={'formuploadInput'}
              downloadClassName={'formdownloadInput'}
              Attachments={formObject.Attachments}
              fileUpload={(values, key, fileDataObject) => {
                fileupload(values, key, fileDataObject);
              }}
            />
          </Form.Item>
          <Form.Item style={{ width: '100%', flex: '50%' }}>
            <InputComponent style={{ display: 'none' }} />
          </Form.Item>
        </div>

        <Form style={{ padding: '0px' }}>
          <Tabs
            defaultActiveKey={activeKey}
            onChange={(activeKey) => setActiveKey(activeKey)}
            type="card"
          >
            <TabPane tab={translation(translationCache, constant.jobPlanTasks)} key="1">
              <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                <Form.Item
                  label={translation(translationCache, constant.selectJobPlan)}
                  name="JobPlanName"
                  style={{ width: '100%', flex: '50%' }}
                >
                  <Select
                    placeholder={translation(translationCache, 'Select JobPlan')}
                    defaultValue={formObject.JobPlan}
                    style={{ width: '70%' }}
                    onChange={(value) => jobPlanOnChange(value)}
                  >
                    {jobPlansList.map((jobplan, index) => (
                      <Option
                        key={index}
                        value={jobplan.Id}
                        disabled={
                          workOrderRef.current &&
                          workOrderRef.current.getFieldsValue() &&
                          workOrderRef.current.getFieldsValue().JobPlan &&
                          workOrderRef.current.getFieldsValue().JobPlan.JobPlanName === jobplan.JobPlanName
                        }
                      >
                        {jobplan.JobPlanName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>

                <Form.Item label="Attachments" style={{ width: '100%', flex: '50%' }}>
                  <FileBase64
                    downloadClassName={'downloadInput'}
                    Attachments={
                      formObject.JobPlan && formObject.JobPlan.Attachments ? formObject.JobPlan.Attachments : {}
                    }
                    fileUpload={(values, key, fileDataObject) => {
                      jobPlanfileUpload(
                        values,
                        key,
                        fileDataObject,
                        formObject.JobPlan && formObject.JobPlan.Id ? formObject.JobPlan.Id : ''
                      );
                    }}
                  />
                </Form.Item>
              </div>

              <Form.Item name="JobPlan" style={{ width: '100%', flex: '50%' }}>
                {(selectedJobPlan && selectedJobPlan !== '') || (formObject.JobPlan && formObject.JobPlan.Id) ? (
                  <WorkOrderJobPlanes
                    form={formObject}
                    noJobplan={false}
                    onFinish={onFinish}
                    formObject={formObject.JobPlan}
                    fileData={setFileData}
                    fileUploadListBack={(fileUploadList) => setFileUploadList(fileUploadList)}
                    workOrderStatus={formObject.WOStatusId ? 'CLOSE' : null}
                  />
                ) : null}
                {selectedJobPlan === '' ? (
                  <WorkOrderJobPlanes
                    noJobplan={true}
                    onFinish={onFinish}
                    formObject={formObject.JobPlan}
                    fileData={fileData}
                    workOrderStatus={formObject.WOStatusId}
                    fileUploadListBack={(fileUploadList) => setFileUploadList(fileUploadList)}
                  />
                ) : null}
              </Form.Item>
            </TabPane>

            <TabPane tab={translation(translationCache, constant.schedulingInformationForPM)} key="2">
              <SchedulingWorkOrder
                onFinish={onFinish}
                formObject={formObject.SchedulingWorkOrder}
              />
            </TabPane>

            <TabPane tab={translation(translationCache, constant.responsibility)} key="3">
              <Responsibility
                onFinish={onFinish}
                formObject={formObject.Responsibility}
              />
            </TabPane>
            <TabPane tab={translation(translationCache, constant.followupWork)} key="4">
              <FollowUpWork
                onFinish={onFinish}
                formObject={formObject.FollowUpWork}
              />
            </TabPane>
            <TabPane tab={translation(translationCache, constant.communicationLog)} key="5">
              <CommunicationLog
                onFinish={onFinish}
                formObject={formObject.CommunicationLog}
              />
            </TabPane>
            <TabPane tab={translation(translationCache, constant.failureReport)} key="6">
              <FailureReport
                onFinish={onFinish}
                formObject={formObject.FailureReport}
              />
            </TabPane>
          </Tabs>
        </Form>
      </Form>
    </>
  );
};
const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(WorkOrderDetails);